/* eslint no-var: 0 */
var main = require('./dist/commonjs/index.js').default;
module.exports = main;
module.exports.default = main;